export function calculateFooterHeight() {
    let FooterHeight = document.querySelector('.c-navigation__mobile').offsetHeight;
    if( document.querySelector('.mini-player')) {
        const MiniPlayerHeight = 60;
        FooterHeight += MiniPlayerHeight;        
    }      
    return FooterHeight;       
} 
